/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Eventdatescount2Inputs */

const en_eventdatescount2 = /** @type {(inputs: Eventdatescount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All ${i?.count} dates`)
};

const de_eventdatescount2 = /** @type {(inputs: Eventdatescount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.count} Termine`)
};

/**
* | output |
* | --- |
* | "All {count} dates" |
*
* @param {Eventdatescount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdatescount2 = /** @type {((inputs: Eventdatescount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdatescount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdatescount2(inputs)
	return de_eventdatescount2(inputs)
});
export { eventdatescount2 as "eventDatesCount" }